/* global axios */
import ApiClient from '../ApiClient';

class KanbanCardsAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }

  index(boardId, params = {}) {
    return axios.get(`${this.url}/${boardId}/cards`, { params });
  }

  create(boardId, data) {
    return axios.post(`${this.url}/${boardId}/cards`, { kanban_card: data });
  }

  update(boardId, cardId, data) {
    return axios.patch(`${this.url}/${boardId}/cards/${cardId}`, {
      kanban_card: data,
    });
  }

  delete(boardId, cardId) {
    return axios.delete(`${this.url}/${boardId}/cards/${cardId}`);
  }

  reorder(boardId, kanbanColumnId, orderedIds) {
    return axios.post(`${this.url}/${boardId}/cards/reorder`, {
      kanban_column_id: kanbanColumnId,
      ordered_ids: orderedIds,
    });
  }
}

export default new KanbanCardsAPI();
